import React, { useEffect, useState } from 'react'
import 'react-toastify/dist/ReactToastify.css'
import '../../../Styles/list-Page.scss'
import editGreen from './../../../imgs/EditGreen.png'
import Delete from './../../../imgs/recycle.png'
import View from './../../../imgs/view.png'
import setingGreen from './../../../imgs/SettingGreen.png'
import { archiveRuleById, getRulesByDataModelId } from '../../../store/rule/api'
import { getDataById, getDataModel } from '../../../store/model/api'
import { handleError } from '../../../utils/handleErrors'
import { FlowDetail } from '../FlowList/FlowDetail'
import { formatDate } from '../../../Services/dateFormat'
import ListPage from '../../Organisms/ListPage/ListPage'
import { RuleListHeader } from './RuleListHeader'
import { RuleDetails } from './RuleDetails'
import { getEntityVersionById } from '../../../store/common/api'
import { ArchivePopup } from '../../Organisms/Popups/General/ArchivePopup'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'

const entityType = 'rule'
export const RuleList = (props) => {
    const [showPopup, setShowPopup] = useState(false)
    const [archivePopupId, setArchivePopupId] = useState(null)
    const [name, setName] = useState()
    const [key, setKey] = useState()
    const [versions, setVersions] = useState()
    const [dataModel, setDataModel] = useState()
    const [dataModels, setDataModels] = useState([])
    const [ruleDetail, setRuleDetail] = useState(null)
    const GROUPS = {
        1: 'Borrower',
        5: 'Pledger',
        11: 'Client',
        9: 'Contact person',
        3: 'Guarantor',
        12: 'Seller',
        2: 'Co-borrower',
        4: 'Spouse',
    }

    const TYPES = { 1: 'Rejection', 2: 'Limit Calculation' }
    const RULE_GROUPS = {
        1: 'Client Characteristics',
        2: 'Creditworthiness',
        3: 'Solvency',
        4: 'Limit Calculations',
    }
    const STATUSES_BY_KEY = {
        0: 'Archived',
        1: 'Draft',
        2: 'In review',
        3: 'Approved',
        4: 'Declined',
    }
    const history = useHistory()

    useEffect(() => {
        getDataModel().then((_dataModels) => {
            setDataModels(_dataModels)
            const dataModelId = localStorage.getItem('dataModelId')
            setDataModel(dataModelId || _dataModels?.[0]?._id)
        })
    }, [])
    const openRuleDetail = (id) => {
        getEntityVersionById(id, entityType)
            .then((versions) => {
                setVersions(versions)
                if (versions && versions.length > 0) {
                    setRuleDetail(versions[0])
                }
            })
            .catch(handleError)
    }
    const viewRule = (item) => {
        history.push(`${window.location.pathname}/${item.data._id}?type=view`)
    }

    const deleteRule = () => {
        archiveRuleById(archivePopupId)
            .then((versions) => {
                setArchivePopupId(null)
                setVersions(versions)
                if (versions && versions.length > 0) {
                    setVersions(versions[0])
                }
                toast.success('Rule deleted successfully')
            })
            .catch(handleError)
    }

    const editDataItem = (item) => {
        getDataById({ id: item.data.modelId })
            .then((dataById) => {
                setShowPopup(true)
                setName(item.data.name)
                setVersions(item.data.version)
                setKey(item.data.key)
            })
            .catch(handleError)
    }
    const closeRuleDetail = () => {
        setRuleDetail(false)
    }

    const rulessTableColumn = [
        { field: 'name', filter: true },
        {
            field: 'type',
            filter: true,
            valueGetter: (params) => {
                return RULE_GROUPS[params.data.type]
            },
        },
        {
            headerName: 'Roles',
            field: 'roles',
            filter: true,
            valueGetter: (params) => {
                return params?.data?.groups
                    .map((groupValue) => GROUPS[groupValue] || '')
                    .filter((name) => name !== '')
                    .join(', ')
            },
        },
        {
            field: 'status',
            filter: true,
            valueGetter: (params) => {
                return STATUSES_BY_KEY[params.data.status]
            },
        },
        {
            headerName: 'Last Modified By',
            field: 'user',
            filter: 'agDateColumnFilter',
        },
        {
            headerName: 'Last Modified Date',
            field: 'createdAt',
            filter: true,
            sort: true,
            valueGetter: (params) => {
                return formatDate(new Date(params.data.createdAt))
            },
        },
        {
            field: 'Actions',
            cellRenderer: (params) => {
                return (
                    <div className="icons">
                        <img
                            src={editGreen}
                            onClick={() => editDataItem(params)}
                            style={{ cursor: 'pointer', paddingRight: '5px' }}
                        />{' '}
                        <img
                            src={setingGreen}
                            onClick={(event) => {
                                event.stopPropagation()
                                event.preventDefault()
                                openRuleDetail(params.data._id)
                            }}
                            style={{ cursor: 'pointer' }}
                        />
                        <img
                            src={Delete}
                            onClick={(event) => {
                                event.stopPropagation()
                                event.preventDefault()
                                setArchivePopupId(params.data._id)
                            }}
                            style={{ cursor: 'pointer', paddingRight: '5px' }}
                        />{' '}
                        <img
                            src={View}
                            onClick={(event) => {
                                event.stopPropagation()
                                event.preventDefault()
                                viewRule(params)
                            }}
                            style={{ cursor: 'pointer', paddingRight: '5px' }}
                        />{' '}
                    </div>
                )
            },
        },
    ]
    return (
        <>
            <ArchivePopup
                isOpen={!!archivePopupId}
                togglePanel={setArchivePopupId}
                onDelete={() => deleteRule()}
            ></ArchivePopup>
            <div className={'tableWrapper'}>
                {ruleDetail ? (
                    <RuleDetails
                        details={ruleDetail}
                        versions={versions}
                        close={() => {
                            setRuleDetail(null)
                        }}
                    />
                ) : null}
                {dataModel ? (
                    <ListPage
                        pg="20"
                        triggerCall={dataModel}
                        dataModelCall={getDataModel}
                        dataCall={() =>
                            getRulesByDataModelId(
                                { modelId: dataModel },
                                dataModels,
                            )
                        }
                        tableColumns={rulessTableColumn}
                        parameterPanel={FlowDetail}
                        ruleDetail={ruleDetail}
                        setRulerDetail={setRuleDetail}
                        closeRuleDetail={closeRuleDetail}
                        setOpenPanel={props.setOpenPanel}
                        editDataItem={editDataItem}
                        HeaderComponent={() => (
                            <RuleListHeader
                                dataModel={dataModel}
                                setDataModel={setDataModel}
                                dataModels={dataModels}
                            />
                        )}
                    />
                ) : null}
            </div>
        </>
    )
}
